import { API } from "../../../utils/api";

export const getFinishedProductsList = async ({ query, pagination }) => {
  let paginatinParams = "";
  if (pagination) {
    const { pageIndex, pageSize } = pagination;
    paginatinParams = `page=${pageIndex}&per_page=${pageSize}`;
  }
  const res = await API.get(
    `pos-sync/finished-products?${paginatinParams}`,
    query,
  );
  return res.data.data;
};

export const getSyncHistoryList = async ({ query, pagination }) => {
  const { pageIndex, pageSize } = pagination;
  const res = await API.get(
    `pos-sync/history?page=${pageIndex}&per_page=${pageSize}`,
    query,
  );
  return res.data.data;
};

export const getSyncHistoryDetails = async ({ id }) => {
  const res = await API.get(`pos-sync/history/${id}`);
  return res.data.data;
};

export const getSyncScheduledList = async ({ query, pagination }) => {
  const { pageIndex, pageSize } = pagination;
  const res = await API.get(
    `pos-sync/scheduled?page=${pageIndex}&per_page=${pageSize}`,
    query,
  );
  return res.data.data;
};

export const updateScheduledSync = async ({ id, payload }) => {
  const res = await API.put(`pos-sync/scheduled/${id}`, payload);
  return res.data;
};

export const deleteScheduledSync = async ({ id }) => {
  const res = await API.delete(`pos-sync/scheduled/${id}`);
  return res.data;
};

export const updatePOSSyncApi = async (payload) => {
  const res = await API.post(`pos/sync`, payload);
  return res.data;
};

export const changeDefaultStatusApi = async ({ id }) => {
  const res = await API.post(`recipes/${id}/set-default`);
  return res.data;
};

export const getPOSSyncSettings = async () => {
  const res = await API.get(`pos-sync/settings`);
  return res.data.data;
};

export const updatePOSSyncSettings = async (payload) => {
  const res = await API.put(`pos-sync/settings`, payload);
  return res.data;
};
